import _ from 'lodash';

import { lsAddressHelpers } from '@/helpers/address';
import { lsStorageService } from 'ls-vue-common';
import { savedAddressModuleConstants } from '@/services/storage/storage-key.constants';
import * as types from '../types';

export const _private = {
    googlePlaceDefaults: {
        // values from google
        address_components: [],
        street_number: '',
        place_id: '',
        formatted_address: '',
        name: '',
        lat: null,
        lng: null,
        // values used in order payload
        city: '',
        country: '',
        state: '',
        street: '',
        zip: '',
    },
};

export const state = {
    manualStreetNumber: '',
    showStandaloneStreetNumber: false,
    googlePlace: _.cloneDeep(_private.googlePlaceDefaults),
};

export const mutations = {
    [types.ADDRESS__MUTATE_ADDRESS](localState, place) {
        // eslint-disable-next-line no-param-reassign
        localState.googlePlace = place;
    },

    [types.ADDRESS__MUTATE_MANUAL_STREET_NUMBER](localState, streetNumber) {
        // eslint-disable-next-line no-param-reassign
        localState.manualStreetNumber = streetNumber;
    },

    [types.ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER](localState, showStreetNumber) {
        // eslint-disable-next-line no-param-reassign
        localState.showStandaloneStreetNumber = Boolean(showStreetNumber);
    },
};

export const actions = {
    [types.ADDRESS__RESUME_ADDRESS]({ commit }, payload) {
        commit(types.ADDRESS__MUTATE_ADDRESS, payload.googlePlace);
        commit(types.ADDRESS__MUTATE_MANUAL_STREET_NUMBER, payload.manualStreetNumber);
        commit(
            types.ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER,
            payload.showStandaloneStreetNumber
        );
    },

    [types.ADDRESS__UPDATE_ADDRESS]({ commit }, payload) {
        commit(types.ADDRESS__MUTATE_ADDRESS, payload);
    },

    // eslint-disable-next-line no-shadow
    [types.ADDRESS__GOOGLE_PREDICTION_SELECTED]({ commit, state }, place) {
        _.defaults(place, _private.googlePlaceDefaults);
        const formattedGooglePlace = lsAddressHelpers.formatPlace({ place });
        const placeMissingStreetNumber = !formattedGooglePlace.street_number;

        commit(types.ADDRESS__MUTATE_ADDRESS, formattedGooglePlace);
        commit(types.ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER, placeMissingStreetNumber);
        commit(types.ADDRESS__MUTATE_MANUAL_STREET_NUMBER, '');
        lsStorageService.set(savedAddressModuleConstants.MODULE, state);
    },

    // eslint-disable-next-line no-shadow
    [types.ADDRESS__UPDATE_MANUAL_STREET_NUMBER]({ commit, state }, streetNumber) {
        commit(types.ADDRESS__MUTATE_MANUAL_STREET_NUMBER, streetNumber);
        lsStorageService.set(savedAddressModuleConstants.MODULE, state);
    },

    // eslint-disable-next-line no-shadow
    [types.ADDRESS__UPDATE_SHOW_STANDALONE_STREET_NUMBER]({ commit, state }, showStreetNumber) {
        commit(types.ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER, showStreetNumber);
        lsStorageService.set(savedAddressModuleConstants.MODULE, state);
    },
};

export const getters = {};
